import convert from 'xml-js';

export default (xml: string) => JSON.parse(
  convert.xml2json(xml, { compact: true }),
);
